import { render, staticRenderFns } from "./LeaseCarousel.vue?vue&type=template&id=bef048a0&scoped=true&"
import script from "./LeaseCarousel.vue?vue&type=script&lang=js&"
export * from "./LeaseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LeaseCarousel.vue?vue&type=style&index=0&id=bef048a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef048a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bef048a0')) {
      api.createRecord('bef048a0', component.options)
    } else {
      api.reload('bef048a0', component.options)
    }
    module.hot.accept("./LeaseCarousel.vue?vue&type=template&id=bef048a0&scoped=true&", function () {
      api.rerender('bef048a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/components/LeaseCarousel.vue"
export default component.exports